<template>
  <span class="info-tooltip">
    <button
      type="button"
      class="info-tooltip__trigger"
      :aria-label="`Mais informações sobre ${label}`"
      @focus="visible = true"
      @blur="visible = false"
      @mouseenter="visible = true"
      @mouseleave="visible = false"
    >
      <svg-loader
        src="/static/images/icon-info-tooltip.svg"
        class="info-tooltip__icon"
      />
    </button>
    <span
      v-if="visible"
      class="info-tooltip__content"
      role="tooltip"
    >
      {{ text }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'InfoTooltip',
  props: {
    label: { type: String, required: true },
    text: { type: String, required: true },
    color: { type: String, default: '#B2B2B2' },
  },
  data() {
    return { visible: false }
  },
}
</script>

<style scoped lang="scss">
.info-tooltip {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.info-tooltip__trigger {
  display: inline-flex;
  width: 17px;
  height: 17px;
  padding: 0;
  border: 0;
  background: transparent;
  color: v-bind(color);
  cursor: help;
}
.info-tooltip__icon {
  width: 17px;
  height: 17px;
  min-width: 17px;
  min-height: 17px;
  margin: 0;
  // definido também aqui (e não só no botão pai) para não depender da cascata de "color" herdado
  color: v-bind(color) !important;
}
.info-tooltip__content {
  position: absolute;
  z-index: 20;
  top: calc(100% + 8px);
  left: 50%;
  width: 280px;
  transform: translateX(-50%);
  padding: 8px;
  border: 1px solid rgba(230, 230, 230, 1);
  border-radius: 4px;
  background: #fff;
  box-shadow:
    0 4px 8px 0 rgba(22, 22, 22, 0.08),
    0 2px 2px 0 rgba(22, 22, 22, 0.04);
  color: rgba(22, 22, 22, 1);
  font:
    400 14px/150% Roboto,
    sans-serif;
  letter-spacing: 0.2px;
  text-align: left;
}
</style>
